import * as React from 'react'
import styled from 'styled-components'
import { inject, observer } from 'mobx-react'
import { ProductType } from 'src/resources'
import { ChangeBtn, EditBtn } from 'src/components/atoms/input/buttons'
import PriceHeadline from 'src/components/atoms/configurator/PriceHeadline'
import ReactHtmlParser from 'react-html-parser'
import {
  MultiImageConfigurator,
  Image
} from 'src/components/containers/configurator/MultiImageConfigurator'
import { StoreProps } from '../../../stores'
import { media } from '../../../utils'
import { CustomOptionalModal } from 'src/components/containers/CustomOptionalModal'

const moreProducts = require('src/assets/configurator/more_products.png')

interface Props extends StoreProps {
  productType: ProductType
  title: string
  defaultImg: any
  defaultDesc: string
  toOpenModal: () => void
  prodcutIncluded?: boolean
}

interface State {
  modal: boolean
}

@inject('confStore')
@observer
export default class ProductRow extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      modal: false
    }
  }

  renderImages = () => {
    const { confStore, defaultImg, productType } = this.props
    const activeProducts = confStore.getProductsOfTypeInOffer(productType)
    const siblings = activeProducts.length - 1
    if (activeProducts.length) {
      return activeProducts.map((p, index) => {
        if (index > 3) return ''
        if (index === 3 && activeProducts.length > 4) {
          return (
            <Image
              selected
              img={moreProducts}
              siblings={siblings}
              key={p.uuid}
            />
          )
        }
        return (
          <Image selected img={p.photos[0]} siblings={siblings} key={p.uuid} />
        )
      })
    }
    return <Image img={defaultImg} />
  }
  openCardEditor = (product) => {
    window.open(product.externalUrl, '_blank')
  }
  editCardButton = (product) => {
    let { confStore } = this.props
    if (product.status === 'pending') {
      return (
        <EditBtn
          status={confStore.getActiveEditObituary}
          id={`view-${product.productType}`}
          onClick={() => this.openCardEditor(product)}>
          Ansehen
        </EditBtn>
      )
    }
    // else{
    //   if(product.productType === "OBITUARY"){
    //     if(confStore.getActiveEditObituary){
    //       return <EditBtn status={confStore.getActiveEditObituary} id={`edit-${product.productType}`} rel="noopener" onClick={() => this.openCardEditor(product)}>{confStore.getActiveEditObituary ? 'Jetzt gestalten' : 'Lädt...'}</EditBtn>
    //     }
    //     return <EditBtn status={confStore.getActiveEditObituary} id={`edit-${product.productType}`} rel="noopener">{confStore.getActiveEditObituary ? 'Jetzt gestalten' : 'Lädt...'}</EditBtn>
    //   }
    //   if(product.productType === "CARD"){
    //     if(confStore.getActiveEditCard){
    //       return <EditBtn status={confStore.getActiveEditCard} id={`edit-${product.productType}`} onClick={() => this.openCardEditor(product)} rel="noopener">{confStore.getActiveEditCard ? 'Jetzt gestalten' : 'Lädt...'}</EditBtn>
    //     }
    //     return <EditBtn status={confStore.getActiveEditCard} id={`edit-${product.productType}`} rel="noopener" >{confStore.getActiveEditCard ? 'Jetzt gestalten' : 'Lädt...'}</EditBtn>
    //   }
    // }
  }
  changeCardButton = (product, productType) => {
    let { confStore } = this.props
    const activeProducts = confStore.getProductsOfTypeInOffer(productType)
    if (product && product.status === 'pending') {
      return (
        <MessageLocked>
          Ihr Trauerdruck wird bearbeitet und bald an Sie versendet.
        </MessageLocked>
      )
    } else {
      return (
        <ChangeBtn
          id={`${activeProducts.length ? 'remove-' : 'add-'}${productType}`}
          onClick={this.changeCardButtonAction}>
          {activeProducts.length ? 'Ändern' : 'Auswählen'}
        </ChangeBtn>
      )
    }
  }
  changeCardButtonAction = (product = null) => {
    let { toOpenModal, confStore, productType } = this.props
    const activeProducts = confStore.getProductsOfTypeInOffer(productType)
    //console.log(productType, activeProducts)
    if (
      (productType === 'OBITUARY' && activeProducts.length) ||
      (productType === 'CARD' && activeProducts.length)
    ) {
      toOpenModal()
    } else {
      toOpenModal()
    }
  }

  renderDescription = () => {
    const { confStore, defaultDesc, productType } = this.props
    let activeProducts = confStore.getProductsOfTypeInOffer(productType)
    if(productType === 'COFFIN'){
      const linings = confStore.getProductsOfTypeInOffer('COFFIN_LINING')
      activeProducts = activeProducts.concat(linings)
    }
    if (activeProducts.length > 1) {
      return (
        <ProductUl>
          {activeProducts.map((p) => {
            return (
              <li key={p.uuid}>
                <p>
                  {p.name}
                  {p.quantity > 1 ? ` (x${p.quantity})` : ''}
                </p>
                <p>€ {confStore.calculateProductPrice(p, p.quantity)}</p>
              </li>
            )
          })}
        </ProductUl>
      )
    }
    if (activeProducts.length) {
      return (
        <React.Fragment>
          {ReactHtmlParser(activeProducts[0].longDescription)}
        </React.Fragment>
      )
    }
    return <p>{defaultDesc}</p>
  }

  render() {
    const { confStore, productType, title, toOpenModal } = this.props
    const { modal } = this.state
    let activeProducts = confStore.getProductsOfTypeInOffer(productType)
    if(productType === 'COFFIN'){
      const linings = confStore.getProductsOfTypeInOffer('COFFIN_LINING')
      activeProducts = activeProducts.concat(linings)
    }
    let cardTitle = title
    let price = 0
    if (activeProducts.length) {
      cardTitle =
        activeProducts.length > 1 ? 'Ihre Auswahl' : activeProducts[0].name
      price = activeProducts.reduce(
        (sum, p) => sum + confStore.calculateProductPrice(p, p.quantity == 0 ? 1 : p.quantity),
        0
      )
    }
    //console.log("type: " + productType)
    //console.log(activeProducts[0])
    if (productType === 'OBITUARY' || productType === 'CARD') {
      try {
        if (activeProducts[0] && activeProducts[0].quantity) {
          cardTitle += ' (x' + activeProducts[0].quantity + ')'
        }
        price = activeProducts[0].total.amount / 100
      } catch (e) {}
    }
    return (
      <React.Fragment>
        <CustomOptionalModal
          title='Achtung!'
          onClose={() => this.setState({ modal: false })}
          onCancel={() => console.log('onCancel')}
          cancelLabel={'Abbrechen'}
          confirmLabel={'Neues Design erstellen'}
          onConfirm={() => {
            confStore.removeProductByUuid(activeProducts[0].uuid)
            this.setState({ modal: false })
            toOpenModal()
          }}
          open={modal}>
          <div className='product-long-desc' style={{ textAlign: 'left' }}>
            Sie haben bereits ein Design gespeichert. Sind Sie sicher, dass sie
            ein neues erstellen wollen? Ihr bisheriger Fortschritt geht dadurch
            verloren.
          </div>
        </CustomOptionalModal>
        <MultiImageConfigurator
          isHighlighted={!!activeProducts.length}
          whiteBgForImages={
            activeProducts.length &&
            !['CARD', 'OBITUARY', 'URN'].includes(activeProducts[0].productType)
          }
          renderImages={this.renderImages}>
          <PriceHeadline
            id={`title-${productType}`}
            service={cardTitle}
            price={activeProducts.length ? price : undefined}
          />
          <div>{this.renderDescription()}</div>
          <ButtonsContainer>
            {this.changeCardButton(activeProducts[0], productType)}
            {/* {productType === 'OBITUARY' && activeProducts.length
              ? this.editCardButton(activeProducts[0])
              : ''}
            {productType === 'CARD' && activeProducts.length
              ? this.editCardButton(activeProducts[0])
              : ''} */}
          </ButtonsContainer>
        </MultiImageConfigurator>
      </React.Fragment>
    )
  }
}

const ProductUl = styled.ul`
  padding: 0 7.5px 0 15px;
  li {
    display: flex;
    &:before {
      display: inline;
      content: '•';
      margin-top: -0.18em;
      margin-right: 7.5px;
      font-size: 20px;
      font-weight: bold;
    }

    p:first-child {
      width: 85%;
      text-align: left;
    }
    p:last-child {
      width: 15%;
      text-align: right;
    }
  }
  ${media.tablet`
    padding: 0;
    li {
      padding: 0;
      p:first-child {
        width: 70%;
      }
      p:last-child {
        width: 30%;
      }
    }
  `}
`

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  min-height: 34px;
`

const MessageLocked = styled.p`
  display: inline;
  font-size: 14px;
  margin: 0px;
`



// WEBPACK FOOTER //
// ./src/components/molecules/configurator/ProductRow.tsx